<template>
  <div class="returns-detailed" v-title data-title="期权明细">
    <section>
     <router-view/>
    </section>
    <footer>
      <earningsTabar :id="id"></earningsTabar>
    </footer>
  </div>
</template>

<script>

import earningsTabar from '../../components/tabar/earnings-tabar'

export default {
  data(){
    return{
      id : ''
    }
  },
  created(){
    this.id = this.$route.query.id
    // console.log(this.id)
  },
  components:{
    earningsTabar
  }
}
</script>

<style lang="less" scoped>
  .returns-detailed{
    width: 7.5rem;  
    height: 100%;
    background-color: #f0f0f091;
    display: flex;
    flex-direction: column;
    section{
      margin-bottom: .97rem;
    }
  }
</style>